'use strict';

var _defineProperty = require("/home/runner/work/neoswap-app-react/neoswap-app-react/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, '__esModule', {
  value: true
});

/** @category Errors */
class NumberOutOfRangeError extends RangeError {
  constructor(serializer, min, max, actual) {
    super(`Serializer [${serializer}] expected number to be between ${min} and ${max}, got ${actual}.`);
    _defineProperty(this, "name", 'NumberOutOfRangeError');
  }
}
exports.NumberOutOfRangeError = NumberOutOfRangeError;
//# sourceMappingURL=errors.cjs.map